import { MatMomentDateAdapterOptions, MomentDateAdapter } from '@angular/material-moment-adapter';
import { Moment } from 'moment';

export const replaceArabicNumbers = (str: string): string =>
  str
    .replace(/٠/g, '0')
    .replace(/١/g, '1')
    .replace(/٢/g, '2')
    .replace(/٣/g, '3')
    .replace(/٤/g, '4')
    .replace(/٥/g, '5')
    .replace(/٦/g, '6')
    .replace(/٧/g, '7')
    .replace(/٨/g, '8')
    .replace(/٩/g, '9');

export const replaceDegreeSign = (str: string): string => str.replace(/º/g, '');
/**
 * In case of arabic language we want to show english numbers, otherwise use the current language's formatting (MAT_DATE_LOCALE)
 */
export class TenDateAdapter extends MomentDateAdapter {
  public suffix = '';

  constructor(
    public locale: string,
    options: MatMomentDateAdapterOptions
  ) {
    super(locale, options);
  }

  public getYearName(date: Moment): string {
    return this.isArabicLanguage() ? `${date.year()}` : super.getYearName(date);
  }

  public getDateNames(): string[] {
    const dateNames = super.getDateNames();

    return this.isArabicLanguage() ? dateNames.map(replaceArabicNumbers) : dateNames;
  }

  public format(date: Moment, displayFormat: string): string {
    let formatted = super.format(date, displayFormat);

    if (this.isArabicLanguage()) {
      const arabicFormatted = replaceArabicNumbers(formatted);
      formatted = this.suffix ? `${this.suffix} ${arabicFormatted}` : arabicFormatted;
    } else {
      formatted = this.suffix ? `${formatted} ${this.suffix}` : formatted;
    }

    if (this.containsDegreeSign(formatted)) {
      formatted = replaceDegreeSign(formatted);
    }

    return formatted;
  }

  private isArabicLanguage(): boolean {
    return this.locale === 'ar-ae';
  }

  private containsDegreeSign(date: string): boolean {
    const degreeSign = /º/gi;

    if (date.match(degreeSign)) {
      return true;
    }

    return false;
  }
}
